/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import OneStopHistoryPage from 'domain/people/employeePortal/history/List';
import { Router, Route } from 'framework/routing';
import { MY_ACTIVITY_ROOT_PATH, useMyActivityRoute } from 'domain/people/employeePortal/MyActivityRouterHelper';
import { ProtectedRouter } from 'infrastructure/routing';

const MyActivityRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { historyRoute } = useMyActivityRoute();

  return (
    <ProtectedRouter basePath={MY_ACTIVITY_ROOT_PATH}>
      <Routes>
        <Route path={historyRoute} element={<OneStopHistoryPage />} />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

MyActivityRouter.getRouterPath = () => `${MY_ACTIVITY_ROOT_PATH}/*`;

export default MyActivityRouter;
